
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'intrasense-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  @Output('navigateEvent') action: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private dialogRef: MatDialog
  ) { }

  ngOnInit(): void {
    this.dialogRef.closeAll();
  }

  navigateTo() {
    this.action.emit(true);
  }
}
